import { AxiosResponse } from 'axios'
import apiRequest from '@/apiRequest'
import ApiRequestPaths from '@/apiRequestPaths'

export interface ProductListParams {
  catalogId: string
  page: number
  perPage: number
}

export interface ProductDetailsParams {
  catalogId: string
  productId: string
}

export default class ProductApiRequest {
  static async getProductsList(productListParams: ProductListParams): Promise<AxiosResponse<any>> {
    const productListUrl = new URL(
      ApiRequestPaths.GET_PRODUCT_LIST.replace('{catalogId}', productListParams.catalogId),
      `${process.env.VUE_APP_API_URL}/api/`,
    )

    productListUrl.searchParams.append('page', productListParams.page.toString())
    productListUrl.searchParams.append('perPage', productListParams.perPage.toString())

    return apiRequest.get<any>(productListUrl.href)
  }

  static async getProductVariants(productDetailsRequest: ProductDetailsParams): Promise<AxiosResponse<any>> {
    const productDetailsUrl = new URL(
      ApiRequestPaths.GET_PRODUCT_FROM_CATALOG
        .replace('{catalogId}', productDetailsRequest.catalogId)
        .replace('{productId}', productDetailsRequest.productId),
      `${process.env.VUE_APP_API_URL}/api/`,
    )

    return apiRequest.get<any>(productDetailsUrl.href)
  }

  static async getAllImagesDetails(productDetailsRequest: ProductDetailsParams): Promise<AxiosResponse<any>> {
    const productDetailsUrl = new URL(
      ApiRequestPaths.GET_PRODUCT_IMAGES_DETAILS
        .replace('{catalogId}', productDetailsRequest.catalogId)
        .replace('{productId}', productDetailsRequest.productId),
      `${process.env.VUE_APP_API_URL}/api/`,
    )

    return apiRequest.get<any>(productDetailsUrl.href)
  }
}
